module.exports = __webpack_public_path__ + "static/gpsati_logo-f3bc9329316340d42f58322cb9bfcd64.png";